import { apiClient } from './client';

/**
 * 방 공지 API (room-notice — 서버·앱은 2026-07-15 에 이미 배포됨, PC 화면만 뒤늦게 붙인다).
 *
 * 서버 라우트는 그대로 쓴다 — `GET/PUT/DELETE /api/v1/chat/rooms/:id/notice`.
 *   조회 : 멤버 누구나 (비멤버 404)
 *   등록·삭제 : **방장(OWNER)만** (비-방장 403)
 *   본문 : 글자 500자까지. **첨부는 없다**(서버 스키마에 text 한 칸뿐).
 *   빈 문자열을 PUT 하면 삭제와 같다.
 *
 * 왜 별도 파일인가: 방 응답(serializeRoom)에도 notice 세 칸이 이미 실려 오지만, 프론트의
 * 방 타입은 yaml SSOT 에서 생성한 것이라 그 칸이 없다. 생성 타입을 건드리는 대신 이 API 를
 * 따로 두어 **기존 방 조회 경로는 한 줄도 바꾸지 않는다**(additive).
 */

export interface RoomNotice {
  text: string;
  /** 마지막으로 등록한 사람 id. 서버가 못 찾으면 null. */
  updatedBy: string | null;
  updatedByName: string | null;
  updatedAt: string | null;
}

/** 공지 조회. 등록된 공지가 없으면 null. */
export async function getRoomNotice(roomId: string): Promise<RoomNotice | null> {
  const { data } = await apiClient.get<{ notice: RoomNotice | null }>(`/chat/rooms/${roomId}/notice`);
  return data.notice ?? null;
}

/**
 * 공지 등록·수정. 방장만 호출할 수 있다(그 외 403).
 * 빈 문자열을 주면 서버가 삭제로 처리한다 — 호출부는 `removeRoomNotice` 를 쓰는 편이 뜻이 분명하다.
 */
export async function putRoomNotice(roomId: string, text: string): Promise<RoomNotice | null> {
  const { data } = await apiClient.put<{ notice: RoomNotice | null }>(`/chat/rooms/${roomId}/notice`, { text });
  return data.notice ?? null;
}

/** 공지 내리기. 방장만. */
export async function removeRoomNotice(roomId: string): Promise<void> {
  await apiClient.delete(`/chat/rooms/${roomId}/notice`);
}
